<div>
  <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" [selectedIndex]="selectedIndex" 
    (selectedTabChange)="onInnerTabChange($event.index)" class="labdatatab">
    <mat-tab label="Chemistry">
      <ng-template matTabContent>
        <app-chemistry  [filterState]="filterState()" 
        [refreshTrigger]="refreshTrigger()" [gridSearchText]="gridSearchText()"></app-chemistry>
      </ng-template>
    </mat-tab>
    <mat-tab label="Metals">
      <ng-template matTabContent>
        <app-metals  [filterState]="filterState()" 
        [refreshTrigger]="refreshTrigger()" [gridSearchText]="gridSearchText()"></app-metals>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>